import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useInView } from '../hooks/useInView';
const timelineBenefits = [{
  time: 'En 7 días',
  text: 'vas a saber exactamente a dónde va tu dinero por primera vez en años'
}, {
  time: 'En 30 días',
  text: 'vas a terminar el mes con plata en la cuenta — no mucho, pero algo. Y eso cambia todo'
}, {
  time: 'En 60 días',
  text: 'vas a tener tu primer fondo de emergencia activo, aunque sea pequeño'
}, {
  time: 'En 90 días',
  text: 'vas a estar haciendo tu primera micro-inversión con dinero que antes "desaparecía"'
}];
const lifestyleBenefits = ['Ya no vas a entrar en pánico cuando llega un gasto imprevisto', 'Ya no vas a pelear por plata con tu pareja o sentirte mal por tus gastos', 'Ya no vas a llegar al día 20 del mes mirando la cuenta con angustia'];
export function BenefitsTimeline() {
  const {
    ref: headerRef,
    isVisible: headerVis
  } = useInView();
  const {
    ref: timelineRef,
    isVisible: timelineVis
  } = useInView();
  const {
    ref: lifestyleRef,
    isVisible: lifestyleVis
  } = useInView();
  return <section className="py-24 px-4 bg-[#0F0F0F]" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div ref={headerRef} className={`text-center mb-16 ${headerVis ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-16">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-17">
            BENEFICIOS TRADUCIDOS A VIDA REAL
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-18" />
        </div>

        <div className="space-y-12" data-id="element-19">
          <div ref={timelineRef} className="relative border-l-2 border-gray-800 ml-4 md:ml-8 space-y-10 py-4" data-id="element-20">
            {timelineBenefits.map((benefit, index) => <div key={index} className={`relative pl-8 md:pl-12 ${timelineVis ? `anim-fade-left anim-delay-${index + 1}` : 'anim-hidden'}`} data-id="element-21">
                <div className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-gold-500 shadow-[0_0_10px_rgba(212,168,83,0.5)]" data-id="element-22" />
                <p className="text-xl md:text-2xl text-gray-300" data-id="element-23">
                  <strong className="text-gold-400 block md:inline mb-1 md:mb-0 md:mr-2" data-id="element-24">
                    {benefit.time}
                  </strong>
                  {benefit.text}
                </p>
              </div>)}
          </div>

          <div ref={lifestyleRef} className={`bg-[#141414] rounded-2xl p-8 md:p-10 border border-gray-800 mt-12 ${lifestyleVis ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-25">
            <div className="space-y-6" data-id="element-26">
              {lifestyleBenefits.map((benefit, index) => <div key={index} className={`flex items-start gap-4 ${lifestyleVis ? `anim-fade-up anim-delay-${index + 1}` : ''}`} data-id="element-27">
                  <CheckCircle2 className="w-6 h-6 text-gold-500 shrink-0 mt-0.5" data-id="element-28" />
                  <p className="text-lg md:text-xl text-white font-medium" data-id="element-29">
                    {benefit}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}